import axiosInstance from "utils/axios-request";
import {baseUrl, gatewayUrl} from "config";
import {getIdToken} from "service";
import {ILoanProducts} from "loan-application/interface";

export interface IAllowNewApplication {
    err: string;
    isAllowNewApplication: boolean;
}

export const getCompanyInfo = (query: string) =>
    axiosInstance.request({
        baseURL: gatewayUrl,
        url: `/company-info/?q=${query}`,
        method: "get",
    });

export const getLamProfile = (userId: number) =>
    axiosInstance.request({
        baseURL: gatewayUrl,
        url: `lam-profile/profile?userId=${userId}`,
        method: "get",
    });

export const postEligibilityCheck = (inputFields) =>
    axiosInstance.request({
        baseURL: gatewayUrl,
        url: `/loan-application/eligible-loan-products`,
        method: "get",
        params: inputFields,
    });

export const getApplicationFields = (productCode: string, userId: number) =>
    axiosInstance.request({
        baseURL: gatewayUrl,
        url: `paandu/application-fields`,
        method: "get",
        params: {productCode},
    });

export const createApplication = (userId: number, productType: string, workCin: string, sourcingCode: string) => {
    // TODO : Need to clean this once paandu application creation completed.
    return axiosInstance.request({
        baseURL: gatewayUrl,
        url: `/paandu/application`,
        method: "post",
        data: {
            productCode: productType,
            userId,
            useApplicationLambda: workCin === "L74140KA2007PLC043909" || sourcingCode === "QUESSCORP", // QUESS
        },
    });
};

export const saveMessages = (userId: number, type: string, data: string) => {
    return axiosInstance.request({
        baseURL: baseUrl,
        url: `mobileData/saveMobileData/${userId}`,
        method: "post",
        data: {
            type,
            data,
            facebookToken: getIdToken(),
        },
    });
};

export const getKycModes = (productCode: string) =>
    axiosInstance.request({
        baseURL: gatewayUrl,
        url: `/paandu/kyc-modes`,
        method: "get",
        params: {productCode},
    });

export const getLoanProducts = async (): Promise<{product_specs: ILoanProducts[]}> => {
    const response = await axiosInstance.request({
        baseURL: gatewayUrl,
        url: `paandu/eligible-loan-products`,
        method: "get",
    });
    return response.data;
};

export const getAllowNewApplication = async (): Promise<IAllowNewApplication> => {
    const response = await axiosInstance.request({
        baseURL: gatewayUrl,
        url: "paandu/allow-new-application",
        method: "get",
    });
    return response.data;
};
